import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import BackgroundStyle from './components/shared/BackgroundStylePage'
import { AuthProvider } from './context/authContext'
import { DataProvider } from './context/dataContext';
import { ProtectedRoute } from './services/ProtectedRoute'
import DashboardLayout from './layouts/DashboardLayout';
import { Login, Register, Paneles, PanelDetail, Users, Cruds, Logout, PanelStatus } from './pages';

function App() {
  return (

    <BrowserRouter>
      <AuthProvider>
        <DataProvider>
          <Routes>
            <Route path='/' element={
              <ProtectedRoute>
                <BackgroundStyle>
                  <Login />
                </BackgroundStyle>
              </ProtectedRoute>
            } />
            <Route path='/Register' element={
              <ProtectedRoute>
                <BackgroundStyle>
                  <Register />
                </BackgroundStyle>
              </ProtectedRoute>
            } />
            <Route path='/Dashboard' element={
              <ProtectedRoute Pages>
                <DashboardLayout />
              </ProtectedRoute>
            }>
              {/* <Route path='Usuarios' element={<Users />} /> */}
              <Route path='Actividades' element={<ProtectedRoute Protect Pages><Cruds /></ProtectedRoute>} />
              <Route path='Panel' element={<Paneles />} />
              <Route path='Panel/:ident' element={<PanelDetail />} />
              <Route path='Conexion/:ident' element={<ProtectedRoute Protect Pages Maintenance><PanelStatus /></ProtectedRoute>} />
              {/* <Route path='Conexion/:ident' element={<PanelStatus />} /> */}
              <Route path='' element={<Navigate to='/Dashboard/Panel' replace />} />
            </Route>
            <Route path='/logout' element={
              <Logout>
                <BackgroundStyle>
                </BackgroundStyle>
              </Logout>} />
            <Route path='*' element={<Navigate to='/' replace />} />
          </Routes>
        </DataProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
